import { APPKEY } from 'public/config'
import cloneDeep from 'lodash/cloneDeep'
import { http } from '@/public/utils/http'
/**
 * 获取子节点数据
 * @param: item key
 * **/
export const getAreaChildren = async (idMap, item, key, isSelectAll) => {
  try {
    let method = 'address.addressBgTerritory.getMultiLevelThinkList'
    let param = {
      method: method,
      jsonrpc: '2.0',
      params: {
        districtID: item.districtID,
        showParam: 0,
      }
    }
    const data = await http(method, param, {
      axios: {
        headers: {
          appkey: APPKEY['kye_map'],
        }
      }
    })
    if (data && data.districtList) {
      return setChildrenData(data.districtList, item, idMap, key, isSelectAll)
    }
  } catch (error) {
    console.log(error)
  }
}

const setChildrenData = (data, item, idMap, key, isSelectAll) => {
  const cloneData = cloneDeep(data)
  const childrenData = cloneData.map((v, vIndex) => {
    const splitName = v.districtName.split('-')
    v.simpleName = splitName[splitName.length - 1]
    v.isChecked = false
    v._erpZoom = key
    v._parent = item
    v.districtAllId = v.allDistrictID || v.allDistrictId
    v.childrenNode = []
    idMap.set(v.districtID, v)
    return v
  })
  let childrenList = []
  if (isSelectAll) {
    childrenList = [{
      simpleName: '全选',
      isChecked: false,
      isChoose: false,
      noChildrent: true,
      districtLevel: item.districtLevel,
      _erpZoom: key,
      _parent: item
    }, ...childrenData]
  } else {
    childrenList = [{
      simpleName: '不限',
      isChecked: false,
      isChoose: false,
      districtLevel: item.districtLevel,
      _erpZoom: key,
      _parent: item
    }, ...childrenData]
  }
  item.childrenNode = childrenList
  return childrenList
}

/**
 *
 * @param {*} id
 * @param {*} idMap
 */
export const getAreaLinkData = async (idArry, idMap, areaTree, isSelectAll) => {
  try {
    if (!idArry || !idArry.length) {
      return
    }
    const data = await http('address.regionInfo.getInfoByDistrictId', {districtIds: idArry}, {
      axios: {
        headers: {
          appkey: APPKEY['kye_map'],
        }
      }
    })
    if (data) {
      // 大区对象
      const treeData = data.childrenNode
      const newMap = new Map()
      const loopSetMap = function (mapData) {
        // 当前接口districtName不存在完整链路，地图提供新字段用于代替， 可能存在没有的情况下，比如大区。
        if (mapData.allDistrictName) {
          mapData.districtName = mapData.allDistrictName
        }
        newMap.set(mapData.districtID, mapData)
        mapData.childrenNode && mapData.childrenNode.forEach(item => {
          loopSetMap(item)
        })
      }
      treeData.forEach(item => {
        loopSetMap(item)
      })
      const loopAreaSet = function (areaItem) {
        if (areaItem.districtID) {
          // 排除不限
          const childrenData = newMap.get(areaItem.districtID)
          if (!childrenData || !childrenData.childrenNode) {
            return
          }
          setChildrenData(childrenData.childrenNode, areaItem, idMap, areaItem.level || areaItem._erpZoom + 1, isSelectAll)
          areaItem.childrenNode.forEach(item => {
            loopAreaSet(item)
          })
        }
      }
      areaTree.childrenNode.forEach(areaItem => {
        loopAreaSet(areaItem)
      })
    }
  } catch (error) {
    console.log(error)
  }
}

export const batchSearchFetch = async function (val, batchPateSeparator) {
  try {
    const data = await http('address.regioninfo.areaBatchParser', {
      areas: val,
      separator: batchPateSeparator
    }, {appkey: 55844})
    return data
  } catch (error) {
    console.log(error)
  }
}

/**
 * 下拉搜索查询
 * @param: item key
 * **/
export const searchFetch = async function (val) {
  try {
    console.log('searchFetch------', val)
    if (val && val.length > 1) {
      let method = 'address.regioninfo.getAreaAddress'
      // let method = 'address.regioninfo.areaBatchParser'
      let params = {}
      if (Number(val)) {
        params.zoneCode = val
      } else {
        params.keyWord = val
      }
      let param = {
        jsonrpc: '2.0',
        params,
      }
      const data = await http(method, param, {
        // 写死首页menu-id
        axios: {
          headers: {
            appkey: APPKEY['kye_map'],
          }
        }
      })
      if (data && data.districtList) {
        const reg = new RegExp(val, 'gi')
        const resultData = data.districtList.map((item, index) => {
          return {
            value: `${item.districtName}(${item.districAllName})`,
            id: item.districtID,
            districtName: item.districAllName,
            $value: `${item.districtName.replace(reg, value => `<span style="color: #7653D6;">${value}</span>`)}(${item.districAllName})`,
            districtLevel: item.districtLevel,
            districtAllId: item.districAllId,
            districtAllName: item.districAllName,
            zoneCode: item.zoneCode
          }
        })
        return resultData
      }
    } else {
      this.$message.warning('请至少输入2个字符')
      this.$refs.search.loading = false
      return null
    }
  } catch (error) {
    console.log(error)
    return null
  }
}

/**
 * 向上(父级)递归数据处理
 * @param: item
 * **/
export const setFather = (item, isSelectAll) => {
  if (item._parent && item._erpZoom !== 0) {
    const bortherItem = item._parent.childrenNode.slice(1, item._parent.childrenNode.length)
    const allChecked = bortherItem.every((item) => {
      return item.isChecked
    })
    const allNoChecked = item._parent.childrenNode.every((item) => {
      return item.isChecked === false
    })
    const someIndeterminate = item._parent.childrenNode.some((item) => {
      return item.isIndeterminate === true
    })
    const firstItem = item._parent.childrenNode[0].isChecked
    item._parent._parent && item._parent._parent.childrenNode.forEach(item => {
      item.isChoose = false
    })
    item._parent.isChoose = true
    console.log('firstItem')
    item._parent.isChecked = firstItem || allChecked
    item._parent.isIndeterminate = firstItem ? false : (someIndeterminate || !(allNoChecked || allChecked))
    if (item._parent._parent && item._erpZoom !== 1) {
      if (!isSelectAll) {
        item._parent._parent.childrenNode[0].isChecked = false
      } else {
        const isChecked = item._parent._parent.childrenNode.filter((item, index) => index !== 0).every(item => item.isChecked)
        const isIndeterminate = item._parent._parent.childrenNode.filter((item, index) => index !== 0).some(item => item.isChecked)
        item._parent._parent.childrenNode[0].isChecked = isChecked
        item._parent._parent.childrenNode[0].isIndeterminate = isChecked ? false : isIndeterminate
      }
    }
    setFather(item._parent)
  }
}

/**
 * 同级数据处理
 * @param: item itemIndex type
 * **/
export const setPeer = (item, itemIndex, type) => {
  if (itemIndex === 0) {
    item._parent && item._parent.childrenNode.forEach((v, vIndex) => {
      if (v.isChoose || v.isChecked || v.isIndeterminate) {
        clearChildren(v)
      }
      if (vIndex === 0) {
        v.isChecked = type
      } else {
        v.isChecked = false
        v.isIndeterminate = false
      }
      v.isChoose = false
    })
  } else {
    if (item._erpZoom !== 0) {
      item._parent && (item._parent.childrenNode[0].isChecked = false)
    } else {
      item._parent && (item._parent.isChecked = false)
    }
    item._parent && item._parent.childrenNode.forEach((v) => {
      v.isChoose = false
    })
    item.isChoose = type
  }
  item.isChecked = type
  item.isIndeterminate = false
}

/**
 * 向下递归数据处理
 * @param: item
 * **/
export const clearChildren = (item) => {
  item.childrenNode && item.childrenNode.forEach((v) => {
    if (v.isChoose || v.isChecked || v.isIndeterminate) {
      clearChildren(v)
      v.isChoose = false
      v.isChecked = false
      v.isIndeterminate = false
    }
  })
}

/**
 * 清除子节点的choose checked Indeterminate状态
 * @param {*} data
 */
export const clearStatus = (data) => {
  const clearLoop = (item) => {
    item.childrenNode && item.childrenNode.forEach((v) => {
      if (v.isChoose || v.isChecked || v.isIndeterminate) {
        clearLoop(v)
      }
    })
    item.isChoose = false
    item.isChecked = false
    item.isIndeterminate = false
  }
  clearLoop(data)
}

/**
 * 打开当前节点的相关链路
 * @param {*} item
 * @param {*} selectData 链路二维数组
 */
export const openAddressLink = (item, selectData) => {
  const openFatherLink = (currentItem) => {
    const _parent = currentItem._parent
    if (currentItem && currentItem._erpZoom !== 0) {
      _parent.childrenNode && (selectData[currentItem._erpZoom] = _parent.childrenNode)
      openFatherLink(_parent)
    }
  }
  openFatherLink(item)
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area-select/utils.js